export default {
  header: {
    feature: "Support",
    heading: "Contact Us",
    description:
      "Please fill in the details of your query below and one of our Dataships' Support team will be in touch with you as soon as possible.",
  },
};
